<div class="d-flex flex-wrap card-container mb-4">
    <div class="custom-card">
        <div class="title d-flex gap-1">
            <img src="assets/images/icons/date-and-time-g.svg" alt="" />
            <h3 class="mb-0">{{ clockData.today_fill }}%</h3>
        </div>
        <div class="sub-title">Daily fill rate</div>
    </div>
    <div class="custom-card">
        <div class="title d-flex gap-1">
            <img src="assets/images/icons/date-and-time-y.svg" alt="" />
            <h3 class="mb-0">{{ clockData.week_fill }}%</h3>
        </div>
        <div class="sub-title">Weekly fill rate</div>
    </div>
    <div class="custom-card">
        <div class="title d-flex gap-1">
            <img src="assets/images/icons/date-and-time-p.svg" alt="" />
            <h3 class="mb-0">{{ clockData.month_fill }}%</h3>
        </div>
        <div class="sub-title">Monthly fill rate</div>
    </div>
    <div class="custom-card">
        <div class="title d-flex gap-1">
            <img src="assets/images/icons/date-and-time-b.svg" alt="" />
            <h3 class="mb-0">{{ clockData.year_fill }}%</h3>
        </div>
        <div class="sub-title">Yearly fill rate</div>
    </div>
</div>


<div class="tab-content  flex-grow-1 d-flex flex-column mt-3" style="position: relative">

    <!-- here instead of ngIf, hidden property is used because  ngIf destroys the content but hidden just hides the content-->
    <div class="tab-box align-items-center gap-3  p-24" style="flex-wrap: wrap">

        <div class="custom-tab me-auto">
            <div class="d-flex justify-content-center align-items-center tab-item " id="i-4"
                (click)="onTabChange('today')" [ngClass]="currentTab == 'today' ? 'active-tab' : ''">
                <div class="tab-txt">Today</div>
            </div>
            <div class="d-flex justify-content-center align-items-center tab-item " id="i-1"
                [ngClass]="currentTab == 'timesheet' ? 'active-tab' : ''" (click)="onTabChange('timesheet')">
                <div class="tab-txt">Timesheet</div>
            </div>
        </div>

        <div class="header  p-0 d-flex flex-wrap gap-3">
            <div class="d-flex flex-wrap gap-3 wi-100 ">


                <div class="view-cont">
                    <div class="view-b add-b" (click)="onAddOption()">
                        <div>More</div>
                        <div>
                            <img src="assets/images/icons/down_arrow.svg" class="img-fluid" alt=""
                                [ngClass]="{ 'up-arr' :isAddOption}">
                        </div>
                    </div>
                    <div class="view-box add-option" *ngIf="isAddOption" @fadeAnimation
                        (outSideClick)="isAddOption = false">
                        <div class="v-i pt-2 m-box" (click)="onAssign()">
                            <div class="v-c">Edit Assignment</div>
                        </div>
                        <div class="v-i pt-2 m-box border-t" (click)="onDeleteCurrentData()">
                            <div class="v-c">Delete</div>
                        </div>
                    </div>
                </div>



                <div class="button-con d-flex gap-3">
                    <button class="btn btn-outline-primary d-flex justify-content-center align-items-center"
                        (click)="openRequestModel()">
                        View request
                    </button>
                    <button mat-raised-button color="primary" class="new-btn" (click)="onOpenSetting()">
                        <i class="material-icons me-2">settings</i>Settings
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="border-b"></div>

    <div class="" [hidden]="currentTab != 'today'">
        <div class="d-flex p-24 gap-3">
            <label class="mb-0 d-flex align-items-center" ><input class="c-radio" checked type="radio"
                    name="tab-radio" (change)="onSemiTabChange('clock_request')">Clock request</label>
            <label class="mb-0 d-flex align-items-center"><input class="c-radio" type="radio" name="tab-radio"
                    (change)="onSemiTabChange('not_clocked_tab')">Not Clocked</label>
        </div>
        <div class="border-b"></div>

        <div>
            <div [hidden]="currentSemiTab != 'clock_request'" class="p-24">

                <div class="d-flex align-items-center  gap-3  flex-wrap">
                    <div class="d-flex align-items-center me-auto">
                        <div class="text-semibold me-1">{{tot_clockin_today}}</div>
                        <div class="sub-title">Clocked in today</div>
                    </div>
                    <ng-container>
                        <div class="in-box w-auto">
                            <input class="form-control ps-5" (keyup.enter)="onCloseTodayCal()"
                                [matDatepicker]="sTodayDate" placeholder="Select Date"
                                [(ngModel)]="selectedTodayDate" />
                            <mat-datepicker-toggle matIconSuffix [for]="sTodayDate"></mat-datepicker-toggle>
                            <mat-datepicker #sTodayDate (closed)="onCloseTodayCal()"></mat-datepicker>
                        </div>
                    </ng-container>
                    <div class="search-cont gap-3">
                        <div class="s-in form-input m-0" style="position: relative">
                            <mat-icon class="input-icon">search</mat-icon>
                            <input type="text" placeholder="{{ 'COMMON.SEARCH' | translate }}" class="form-control"
                                [(ngModel)]="objData.today.sh" (input)="onSearch($event, 'today')"
                                (keyup.enter)="onGo('today')" />
                        </div>
                        <div class="go-b m-0" (click)="onGo('today')">
                            {{ "COMMON.GO" | translate }}
                        </div>
                        <div class="s-item d-box m-0" (click)="onFilterView('today')">
                            <img src="assets/images/icons/filter_ic.svg" class="img-fluid" />
                        </div>
                    </div>
                </div>
                <div>
                    <app-filter *ngIf="objData.today.isFilterShow" (childEvent)="callApi($event, 'today')"
                        [fieldCol]="filterArr"></app-filter>
                </div>
                <div class="border-b mt-24"></div>

                <div class="table-container table-container-n">
                    <table mat-table [dataSource]="dataSourceToday" class="mat-elevation-z8 demo-table">
                        <ng-container matColumnDef="time">
                            <th mat-header-cell *matHeaderCellDef>Start - End Time</th>
                            <td mat-cell *matCellDef="let element">
                                <div (click)="onEditClockTime(element)">
                                    {{ element.st_ti }} {{ element.ed_ti }}
                                    <i class="material-icons cursor-pointer">mode_edit</i>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="break_time">
                            <th mat-header-cell *matHeaderCellDef>Break Time</th>
                            <td mat-cell *matCellDef="let element">
                                <div (click)="onEditBreakTime(element)">
                                    {{ element.br_tii }} {{ element.br_tio }}
                                    <i class="material-icons cursor-pointer">mode_edit</i>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Candidate Name</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="user-profile" (click)="openTimeSheetDetailsModel(element)">
                                    <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"></div>
                                    <div class="">
                                        <div class="main-head">
                                            {{ element.first_name }} {{ element.last_name }}
                                        </div>
                                        <div class="sub-head">{{ element.email }}</div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="category">
                            <th mat-header-cell *matHeaderCellDef>Category</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="u-box flex-column">
                                    <div class="name">{{ element.j_c }}</div>
                                    <div class="email">{{ element.j_sc }}</div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef>{{"Address"|translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="hide-lines-2 add-head"> {{element.add}}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="clock-in">
                            <th mat-header-cell *matHeaderCellDef>Clock In</th>
                            <td mat-cell *matCellDef="let element">
                                <a target="blank" *ngIf="element.lat"
                                    [href]="googleMapLink + element.lat + ',' + element.long">
                                    <i class="material-icons "
                                        [ngClass]="element.in_icon == 1 ? 'color-red' : 'color-green' ">location_on</i>
                                </a>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="clock-out">
                            <th mat-header-cell *matHeaderCellDef>Clock out</th>
                            <td mat-cell *matCellDef="let element">
                                <a target="blank" *ngIf="element.c_long"
                                    [href]="googleMapLink + element.c_lat + ',' + element.c_long">
                                    <i class="material-icons"
                                        [ngClass]="element.out_icon == 1 ? 'color-red' : 'color-green' ">location_on</i>
                                </a>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="total-hours">
                            <th mat-header-cell *matHeaderCellDef>Total hours</th>
                            <td mat-cell *matCellDef="let element">{{ element.wo_ti }}</td>
                        </ng-container>
                        <ng-container ntainer matColumnDef="scheduled-hours">
                            <th mat-header-cell *matHeaderCellDef>Scheduled hours</th>
                            <td mat-cell *matCellDef="let element">hello</td>
                        </ng-container>
                        <ng-container matColumnDef="overtime">
                            <th mat-header-cell *matHeaderCellDef>OverTime</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.ov_ti_duration }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-bold st-box d-flex">
                                    <span class="active badge-c d-box" *ngIf="element.app == 1">{{
                                        "Accepted" | translate
                                        }}</span>
                                    <span class="pending badge-c d-box" *ngIf="element.app == 2">{{ "Pending" |
                                        translate }}</span>
                                    <span class="un-attend badge-c d-box" *ngIf="element.app == 0">{{ "Rejected" |
                                        translate }}</span>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="overtime_status">
                            <th mat-header-cell *matHeaderCellDef>OverTime Status</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-bold st-box d-flex">
                                    <span class="active badge-c d-box" *ngIf="element.ov_ti == 1">{{ "Accepted" |
                                        translate }}</span>
                                    <span class="pending badge-c d-box" *ngIf="element.ov_ti == 2">{{ "Pending" |
                                        translate }}</span>
                                    <span class="un-attend badge-c d-box" *ngIf="element.ov_ti == 0">{{ "Rejected" |
                                        translate }}</span>
                                    <span *ngIf="element.ov_ti == 3">-</span>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="accept-reject">
                            <th mat-header-cell *matHeaderCellDef>Accept/reject</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex">
                                    <div class="status-box accept me-2" matTooltip="{{ 'BUTTON.ACCEPT' | translate }}"
                                        [ngClass]="{ opacity: element.app == '1' }"
                                        (click)="confirmationAlert(element, 'status', 'yes')">
                                        <img src="assets/images/icons/tick_correct.svg" class="img-fluid" alt="" />
                                    </div>
                                    <div class="status-box reject" matTooltip="{{ 'BUTTON.REJECT' | translate }}"
                                        [ngClass]="{ opacity: element.app == '0' }"
                                        (click)="confirmationAlert(element, 'status', 'no')">
                                        <img src="assets/images/icons/cancel.svg" class="img-fluid" alt="" />
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="overtime_accept_reject">
                            <th mat-header-cell *matHeaderCellDef>Overtime Accept/reject</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex" *ngIf="element.ov_ti != 3">
                                    <div class="status-box accept me-2" matTooltip="{{ 'BUTTON.ACCEPT' | translate }}"
                                        [ngClass]="{ opacity: element.ov_ti == '1' }"
                                        (click)="confirmationAlert(element, 'overtime', 'yes')">
                                        <img src="assets/images/icons/tick_correct.svg" class="img-fluid" alt="" />
                                    </div>
                                    <div class="status-box reject" matTooltip="{{ 'BUTTON.REJECT' | translate }}"
                                        [ngClass]="{ opacity: element.ov_ti == '0' }"
                                        (click)="confirmationAlert(element, 'overtime', 'no')">
                                        <img src="assets/images/icons/cancel.svg" class="img-fluid" alt="" />
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsF"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsF"></tr>
                    </table>
                </div>

                <div class="pagination-cont" *ngIf="dataSourceToday?.data?.length != 0">
                    <div class="show-item">
                        {{ "COMMON.SIP" | translate }}
                        <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event, 'today')"
                            [(ngModel)]="objData.today.itemsPerPage">
                            <option [value]="item" *ngFor="let item of pageSizeOptions">
                                {{ item }}
                            </option>
                        </select>
                    </div>
                    <div class="page-c">
                        <ngb-pagination [collectionSize]="objData.today.count" [(page)]="objData.today.currentPage"
                            [pageSize]="objData.today.itemsPerPage" [maxSize]="objData.today.maxPaginationSize"
                            (pageChange)="onPageChange($event, 'today')"></ngb-pagination>
                    </div>
                </div>

                <div class="mat-table__message position-relative" *ngIf="isSpinnerLoading">
                    <div class="custom-loader"> </div>
                </div>
                <div class="mat-table__message" *ngIf="dataSourceToday?.data?.length == 0 && !isSpinnerLoading">
                    <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
                </div>
            </div>
            <div [hidden]="currentSemiTab != 'not_clocked_tab'" class="p-24">
                <div class="search-cont gap-3">
                    <div class="s-in me-0 form-input" style="position: relative">
                        <mat-icon class="input-icon">search</mat-icon>
                        <input type="text" placeholder="{{ 'COMMON.SEARCH' | translate }}" class="form-control"
                            [(ngModel)]="objData.not_clocked_tab.sh" (input)="onSearch($event, 'not_clocked_tab')"
                            (keyup.enter)="onGo('not_clocked_tab')" />
                    </div>
                    <div class="go-b me-0" (click)="onGo('not_clocked_tab')">
                        {{ "COMMON.GO" | translate }}
                    </div>
                    <div class="s-item d-box" (click)="onFilterView('not_clocked_tab')">
                        <img src="assets/images/icons/filter_ic.svg" class="img-fluid" />
                    </div>
                    <ng-container>
                        <div class="in-box w-auto">
                            <input class="form-control ps-5" (keyup.enter)="onCloseTodayNotClockedCal()"
                                [matDatepicker]="sNcTodayDate" placeholder="Select Date"
                                [(ngModel)]="selectedNotClockedTodayDate" />
                            <mat-datepicker-toggle matIconSuffix [for]="sNcTodayDate"></mat-datepicker-toggle>
                            <mat-datepicker #sNcTodayDate (closed)="onCloseTodayNotClockedCal()"></mat-datepicker>
                        </div>
                    </ng-container>
                </div>
                <div>
                    <app-filter *ngIf="objData.not_clocked_tab.isFilterShow"
                        (childEvent)="callApi($event, 'not_clocked_tab')" [fieldCol]="filterArr"></app-filter>
                </div>
                <div class="table-container table-container-n mt-3">
                    <table mat-table [dataSource]="dataSourceNotclockedIn" class="mat-elevation-z8 demo-table">
                        <!-- Position Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Candidate Name</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="user-profile">
                                    <div class="profile-img me-2 view-employee"
                                        [appBackgroundImg]="element.profile_picture"
                                        (click)="onViewEmployee(element.employee_id)"></div>
                                    <div class="view-employee" (click)="onViewEmployee(element.employee_id)">
                                        <div class="main-head">
                                            {{ element.first_name }} {{ element.last_name }}
                                        </div>
                                        <div class="sub-head">{{ element.email }}</div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="company">
                            <th mat-header-cell *matHeaderCellDef>Company</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="user-profile">
                                    <div class="profile-img me-2 view-employee"
                                        [appBackgroundImg]="element.company_logo"
                                        ></div>
                                    <div class="view-employee" (click)="onViewEmployee(element.employee_id)">
                                        <div class="main-head">
                                            {{ element.company_name }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="category">
                            <th mat-header-cell *matHeaderCellDef>Category</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="main-head">{{ element.j_c }}</div>
                                <div class="sub-head">{{ element.j_sc }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="date">
                            <th mat-header-cell *matHeaderCellDef>Date</th>
                            <td mat-cell *matCellDef="let element">{{ element.st_dt }}</td>
                        </ng-container>
                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef>Address</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="hide-line">{{ element.add }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="shift-time">
                            <th mat-header-cell *matHeaderCellDef>Shift Time</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.c_st_ti }}-{{ element.c_ed_ti }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="phone-number">
                            <th mat-header-cell *matHeaderCellDef>Phone number</th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element.phone_number">{{element.phone_number}} </span>
                                <span class="text-bold" *ngIf="!element.phone_number">-</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>Action</th>
                            <td mat-cell *matCellDef="let element" (click)="onAddTimeForSpecificJob(element)" class="">
                                <span matTooltip="Manage working time">
                                    <i class="material-icons cursor-pointer more-icon">more_vert</i>
                                </span>

                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsC"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsC"></tr>
                    </table>
                </div>
                <div class="pagination-cont" *ngIf="dataSourceNotclockedIn.data.length != 0">
                    <div class="show-item">
                        {{ "COMMON.SIP" | translate }}
                        <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event, 'not_clocked_tab')"
                            [(ngModel)]="objData.not_clocked_tab.itemsPerPage">
                            <option [value]="item" *ngFor="let item of pageSizeOptions">
                                {{ item }}
                            </option>
                        </select>
                    </div>
                    <div class="page-c">
                        <ngb-pagination [collectionSize]="objData.not_clocked_tab.count"
                            [(page)]="objData.not_clocked_tab.currentPage"
                            [pageSize]="objData.not_clocked_tab.itemsPerPage"
                            [maxSize]="objData.not_clocked_tab.maxPaginationSize"
                            (pageChange)="onPageChange($event, 'not_clocked_tab')"></ngb-pagination>
                    </div>
                </div>

                <div class="mat-table__message" *ngIf="dataSourceNotclockedIn.data.length == 0">
                    <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
                </div>
            </div>
        </div>
    </div>

    <div [hidden]="currentTab != 'timesheet'" class="p-24">
        <div class="header d-flex align-items-center flex-wrap p-t-0 gap-3">
            <div class="d-flex me-auto align-items-center flex-wrap me-2 gap-3">
                <div>
                    <mat-form-field class="c-d-r" appearance="fill">
                        <mat-date-range-input [rangePicker]="picker" [formGroup]="dateForm">
                            <input matStartDate placeholder="Start date" formControlName="start"
                                (click)="picker.open()" />
                            <input matEndDate placeholder="End date" formControlName="end" (click)="picker.open()" />
                        </mat-date-range-input>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                    <mat-error *ngIf="
              isControlHasError('start', 'required') ||
              isControlHasError('end', 'required') ">
                        Date Range is required
                    </mat-error>
                </div>

                <!-- <mat-select [value]="'All policy type'" class="form-control s-2 cs-1 cal-view">
                    <mat-option value="All policy type">All Timesheets</mat-option>
                </mat-select> -->
            </div>
            <div class="d-flex flex-wrap gap-3" style="gap: 10px 0px">
                <div class="search-cont gap-3">
                    <div class="s-in me-0 cs-1 me-0 form-input" style="position: relative">
                        <mat-icon class="input-icon">search</mat-icon>
                        <input type="text" placeholder="Search" class="form-control"
                            (input)="onSearch($event, 'timesheet')" [(ngModel)]="objData.timesheet.sh" />
                    </div>
                    <div class="go-b me-0" (click)="onGo('timesheet')">
                        {{ "COMMON.GO" | translate }}
                    </div>
                    <div class="s-item d-box" (click)="onFilterView('timesheet')">
                        <img src="assets/images/icons/filter_ic.svg" class="img-fluid" />
                    </div>
                </div>
                <mat-select [value]="'Export'" class="form-control s-1 cs-1 cal-view"
                    (valueChange)="onValueChange($event)">
                    <mat-option value="Export">Export</mat-option>
                    <mat-option value="payroll_total">Payroll Totals</mat-option>
                    <mat-option value="timesheet">Timesheets</mat-option>
                    <mat-option value="shift_report">Shift Report</mat-option>
                </mat-select>
            </div>
        </div>
        <div>
            <app-filter *ngIf="objData.timesheet.isFilterShow" (childEvent)="callApi($event, 'timesheet')"
                [fieldCol]="filterArr"></app-filter>
        </div>
        <div class="table-container table-container-n">
            <table mat-table [dataSource]="dataSourceTimeSheet" class="mat-elevation-z8 demo-table">
                <ng-container matColumnDef="check-box">
                    <th mat-header-cell *matHeaderCellDef>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox name="schedule"></mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="d-flex user-profile pointer" (click)="openTimeSheetDetailsModel(element)">
                            <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"></div>
                            <div class="">
                                <div class="main-head">
                                    {{ element.first_name }} {{ element.last_name }}
                                </div>
                                <div class="sub-head">{{ element.email }}</div>
                            </div>
                            <img class="cursor-pointer ms-3"
                                (click)="openTimeSheetDetailsModel(element); $event.stopPropagation()"
                                src="assets/images/icons/view_icon.svg" alt="">
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="total-hours">
                    <th mat-header-cell *matHeaderCellDef>Total hours</th>
                    <td mat-cell *matCellDef="let element">{{ element.tot_hour }}</td>
                </ng-container>
                <ng-container matColumnDef="total-w-hours">
                    <th mat-header-cell *matHeaderCellDef>Total working hours</th>
                    <td mat-cell *matCellDef="let element">{{ element.tot_w_hour }}</td>
                </ng-container>
                <ng-container matColumnDef="overtime">
                    <th mat-header-cell *matHeaderCellDef>Overtime</th>
                    <td mat-cell *matCellDef="let element">{{ element.tot_ov_h }}</td>
                </ng-container>
                <!-- <ng-container matColumnDef="paid-time-off">
                    <th mat-header-cell *matHeaderCellDef>Paid time off</th>
                    <td mat-cell *matCellDef="let element">132</td>
                </ng-container> -->
                <ng-container matColumnDef="total-pay">
                    <th mat-header-cell *matHeaderCellDef>Total pay</th>
                    <td mat-cell *matCellDef="let element">{{element?.wages?.toFixed(2)}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
        <div class="pagination-cont" *ngIf="dataSourceTimeSheet.data.length != 0">
            <div class="show-item">
                {{ "COMMON.SIP" | translate }}
                <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event, 'timesheet')"
                    [(ngModel)]="objData.timesheet.itemsPerPage">
                    <option [value]="item" *ngFor="let item of pageSizeOptions">
                        {{ item }}
                    </option>
                </select>
            </div>
            <div class="page-c">
                <ngb-pagination [collectionSize]="objData.timesheet.count" [(page)]="objData.timesheet.currentPage"
                    [pageSize]="objData.timesheet.itemsPerPage" [maxSize]="objData.timesheet.maxPaginationSize"
                    (pageChange)="onPageChange($event, 'timesheet')"></ngb-pagination>
            </div>
        </div>
        <div class="mat-table__message position-relative" *ngIf="isSpinnerLoading">
            <div class="custom-loader"> </div>
        </div>
        <div class="mat-table__message" *ngIf="dataSourceTimeSheet.data.length == 0 && !isSpinnerLoading">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
        </div>
        <div class="mt-4 d-flex flex-column flex-grow-1 j-i-container">
            <div class="header">
                <div class="border-c"></div>
                <h2>Job Insights</h2>
            </div>
            <div class="table-container flex-grow-1">
                <table class="" mat-table [dataSource]="dataSourceJobInsight" class="mat-elevation-z8">
                    <ng-container matColumnDef="category">
                        <th mat-header-cell *matHeaderCellDef>Category</th>
                        <td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="onViewAllJobs(element)">
                            {{ element.j_c }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="total_hour">
                        <th mat-header-cell *matHeaderCellDef>Total Hour</th>
                        <td mat-cell *matCellDef="let element">{{ element.tot_hour }}</td>
                    </ng-container>

                    <ng-container matColumnDef="avg_hour">
                        <th mat-header-cell *matHeaderCellDef class="data-b">
                            Average Hour
                        </th>
                        <td mat-cell *matCellDef="let element" class="data-b">
                            {{ element.tot_hour_avg }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="data-b">
                            Action
                        </th>
                        <td mat-cell *matCellDef="let element" class="data-b">
                            <img class="cursor-pointer" (click)="onViewAllJobs(element)"
                                src="assets/images/icons/view_icon.svg" alt="">
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColJobInsight"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColJobInsight"></tr>
                </table>
            </div>
            <div class="pagination-cont" *ngIf="dataSourceJobInsight.length != 0">
                <div class="show-item">
                    {{ "COMMON.SIP" | translate }}
                    <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event, 'job_insight')"
                        [(ngModel)]="objData.job_insight.itemsPerPage">
                        <option [value]="item" *ngFor="let item of pageSizeOptions">
                            {{ item }}
                        </option>
                    </select>
                </div>
                <div class="page-c">
                    <ngb-pagination [collectionSize]="objData.job_insight.count"
                        [(page)]="objData.job_insight.currentPage" [pageSize]="objData.job_insight.itemsPerPage"
                        [maxSize]="objData.job_insight.maxPaginationSize"
                        (pageChange)="onPageChange($event, 'job_insight')"></ngb-pagination>
                </div>
            </div>

            <div class="mat-table__message position-relative" *ngIf="isSpinnerLoading2">
                <div class="custom-loader"> </div>
            </div>
            <div class="mat-table__message" *ngIf="dataSourceJobInsight.length == 0 && !isSpinnerLoading2">
                <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
            </div>
        </div>
    </div>
</div>

<div [hidden]="currentTab != 'today'" class="tab-content  flex-grow-1  flex-column mt-4" style="position: relative">


    <div class="header d-flex flex-wrap p-24 ">
        <div class="d-flex me-auto flex-wrap me-2 gap-3 align-items-center">
            <!-- <mat-select class="form-control s-1 cs-1 cal-view" [(ngModel)]="clockedVal">
                <mat-option value="all_activity">All activity</mat-option>
                <mat-option value="clocked_in">Clocked in</mat-option>
                <mat-option value="clocked_out">Clocked out</mat-option>
            </mat-select> -->
            <!-- Jobs: -->
            <mat-select [value]="'all_jobs'" class="form-control s-1 cs-1 cal-view">
                <mat-option value="all_jobs">All jobs</mat-option>
            </mat-select>
            <ng-container>
                <div class="in-box w-auto">
                    <input class="form-control ps-5" (keyup.enter)="onCloseCal()" [matDatepicker]="sDate"
                        placeholder="Select Date" [(ngModel)]="selectedDate" />
                    <mat-datepicker-toggle matIconSuffix [for]="sDate"></mat-datepicker-toggle>
                    <mat-datepicker #sDate (closed)="onCloseCal()"></mat-datepicker>
                </div>
            </ng-container>
            <button type="button" class="btn btn-outline-primary" (click)="onToday()">
                Today
            </button>
        </div>
        <div class="d-flex flex-wrap gap-2 me-2">
        </div>
    </div>

    <div class="position-relative p-24 pt-0">
        <div class="c-card" *ngIf="listView">
            <div class="c-card-t">
                <div class="title">All user that clocked in today</div>
                <div class="d-flex me-auto mt-2 flex-wrap me-2 gap-2">
                    <div class="search-cont mb-2">
                        <div class="s-in form-input me-0" style="position: relative">
                            <mat-icon class="input-icon">search</mat-icon>
                            <input type="text" placeholder="{{ 'COMMON.SEARCH' | translate }}" class="form-control"
                                [(ngModel)]="objData.today_tracking.sh" (input)="onSearch($event, 'today_tracking')"
                                (keyup.enter)="searchTrackingUser()" />
                        </div>
                    </div>
                    <button mat-raised-button color="primary" class="new-btn" (click)="onSelectAllEmp()">
                        All
                    </button>
                </div>
                <div class="d-flex user-profiles u-box gap-2 align-items-center justify-content-between"
                    *ngFor="let element of trackData">
                    <div class="d-flex align-items-center user-profile">
                        <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"></div>
                        <div class="">
                            <div class="main-head">
                                {{ element.first_name}} {{ element.last_name }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="route me-2" (click)="onRouteSel(element)"
                            [ngClass]="{ 'route-sel': element.selected == true }">
                            <i class="fas fa-route"></i>
                        </div>
                        <div (click)="onCheckDetails(element)">
                            <img class="arrow-ic" src="assets/images/icons/arrow_next.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="c-card" *ngIf="!listView">
            <div class="c-card-t c-card-t-b">
                <div class="d-flex u-box gap-2 align-items-center">
                    <div class="profile-p me-2" [appBackgroundImg]="insightUserPic"></div>
                    <div class="d-flex align-items-center me-auto">
                        <div class="name">{{insightUser}}</div>
                    </div>

                    <img class="close-ic" src="assets/images/icons/close_icon.svg" (click)="onChangeView()" alt="" />
                </div>
            </div>

            <div *ngFor="let item of dataSourceJobInsight">
                <div class="c-card-b d-flex flex-column gap-2" *ngFor="let uData of item.tr_data; let last = last">
                    <div class="title">{{uData.c_at}}</div>
                    <div class="d-card">
                        <div class="sub-div d-flex align-items-center gap-3 flex-wrap b-bottom">
                            <div *ngIf="item.cl_out == 0 || !last">Clock in</div>
                            <div *ngIf="item.cl_out == 1 && last">Clock out</div>
                            <div class="bedge">{{item.j_sc}}</div>
                        </div>
                        <div class="sub-div d-flex align-items-center gap-2">
                            <img src="assets/images/icons/details_ic.svg" alt="" />
                            <div class="o-line">
                                {{uData.add}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="map"></div>
    </div>
</div>